(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collapsible-content"] && !Shopify.designMode) return;
  try {
    
  if (!window.FarfiCopyEmailInitialized) {
    window.FarfiCopyEmailInitialized = true;

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-copy-email]');
      if (!button) return;

      var email = button.dataset.copyEmail;
      if (!email) return;

      function showCopiedState() {
        button.classList.add('is-copied');
        button.setAttribute('aria-label', 'Адресу електронної пошти скопійовано');

        window.setTimeout(function () {
          button.classList.remove('is-copied');
          button.setAttribute('aria-label', 'Копіювати адресу електронної пошти');
        }, 2000);
      }

      function fallbackCopy() {
        var textarea = document.createElement('textarea');
        textarea.value = email;
        textarea.setAttribute('readonly', '');
        textarea.style.opacity = '0';
        textarea.style.position = 'fixed';
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        textarea.remove();
        showCopiedState();
      }

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(email).then(showCopiedState, fallbackCopy);
      } else {
        fallbackCopy();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
